// extracted by mini-css-extract-plugin
export default {"container":"wellIndexPage_container__c6abp","wellIndexError":"wellIndexPage_wellIndexError__zrPXz","wellIndexLoader":"wellIndexPage_wellIndexLoader__ZqIhq"};